
<template>
  <div>

    <b-button
      v-permission="'roles.create'"
      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
      variant="primary"
      @click="addNew">
      <feather-icon
        icon="PlusIcon"
        class="mr-50"/>
      <span class="align-middle">{{$t('AddNew')}}</span>
    </b-button>

    <Grid :service="service" route_name="roles" :ref="'grid'">
      <template v-slot:actions="actions">
        <div class="flex flex-row gap-2">
          <feather-icon
            v-permission="`roles.edit`"
            icon="EditIcon"
            class="h-5 w-5 mb-1 mr-1 stroke-current text-warning"
            v-tooltip.top="{
              content: 'Editar grupo',
              delay: { show: 100, hide: 100 }
            }"
            @click="edit(actions.row.id)"
          />
          <feather-icon
            icon="CopyIcon"
            class="h-5 w-5 mb-1 mr-1 stroke-current text-primary"
            v-tooltip.top="{
              content: 'Clonar grupo',
              delay: { show: 100, hide: 100 }
            }"
            @click="confirmClone(actions.row.id)"
          />
          <feather-icon
            v-permission="`roles.delete`"
            icon="Trash2Icon"
            class="h-5 w-5 mb-1 mr-1 stroke-current text-danger"
            v-tooltip.top="{
              content: 'Excluir grupo',
              delay: { show: 100, hide: 100 }
            }"
            @click="destroy(actions.row)"
          />
        </div>
      </template>
    </Grid>
  </div>
</template>


<script>
import RoleService from '@/services/api/RoleService'

import { BButton } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  directives: {
    Ripple,
  },
  components: {
    BButton
  },
  data: () => ({
    selected: [],
    service: null
  }),
  methods: {
    addNew() {
      this.$router.push('/roles/create')
    },
    grid() {
      return this.$refs['grid']
    },
    edit(id) {
      const grid = this.grid()
      if (grid) {
        grid.edit(id)
      }
    },
    destroy(data) {
      const grid = this.grid()
      if (grid) {
        grid.destroy(data)
      }
    },
    confirmClone(id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'success',
        title: 'Confirmação',
        acceptText: 'Sim',
        cancelText: 'Não',
        text: 'Tem certeza que deseja clonar este grupo?',
        accept: () => {
          this.clone(id)
        }
      })
    },
    clone(id) {
      this.$vs.loading()
      this.service.clone(id).then(
        response => {
          this.$router.push(`/roles/${response.id}/edit`)
          this.$vs.loading.close()
          this.notifySuccess(
            this.$vs,
            'Grupo clonado com sucesso!',
            2000,
            'center-top'
          )
        },
        error => {
          this.$vs.loading.close()
        }
      )
    },
  },
  beforeMount() {
    this.service = RoleService.build(this.$vs)
  }
}
</script>
